import { createContext } from 'react';

/** Whether the dashboard surface under it is the one on screen. `DashboardHost` keeps every visited surface
 *  mounted, hidden; a surface rendered outside it is always on screen. */
export const DashboardVisibleContext = createContext(true);
